import { BeneficiaryType } from '@seapoint/server/enums';
import { AvatarNameDescription } from '../../../../design-system/avatar/avatar-name-description/avatar-name-description';
import { Checkbox } from '../../../../design-system/checkbox/checkbox';
import { Inline } from '../../../../design-system/inline/inline';
import { SupportedCountryCurrency } from '../../../../types/supported-country-currency';
import { getCurrencyFlag } from '../../../../utils/get-currency-flag';

type BeneficiaryCardProps = {
  isSelected: boolean;
  beneficiaryDetails: {
    id: string;
    name: string;
    destinationConfig:
      | {
          beneficiaryType: BeneficiaryType.IBAN;
          iban: string;
        }
      | {
          beneficiaryType: BeneficiaryType.SCAN;
          accountNumber: string;
          sortCode: string;
        };
  };
  payrollCurrency: SupportedCountryCurrency;
  onSelect: (id: string) => void;
};

export const BeneficiaryCard = ({
  isSelected,
  beneficiaryDetails,
  payrollCurrency,
  onSelect,
}: BeneficiaryCardProps) => {
  const currencyFlag = getCurrencyFlag(payrollCurrency);

  const getAccountDetails = () => {
    switch (beneficiaryDetails.destinationConfig.beneficiaryType) {
      case BeneficiaryType.IBAN:
        return `EUR · ${beneficiaryDetails.destinationConfig.iban}`;
      case BeneficiaryType.SCAN:
        return `GBP · ${beneficiaryDetails.destinationConfig.sortCode} · ${beneficiaryDetails.destinationConfig.accountNumber}`;
      default:
        return '';
    }
  };

  return (
    <label className="block w-full cursor-pointer rounded-lg bg-white p-4 focus-within:ring-2 focus-within:ring-seapoint-yellow">
      <Inline space={3} justify="between">
        <Inline space={2}>
          <Checkbox
            checked={isSelected}
            onCheckedChange={() => {
              onSelect(beneficiaryDetails.id);
            }}
            aria-label={`Select ${beneficiaryDetails.name} to be an employee`}
          />
          <AvatarNameDescription
            avatar={{ showAvatar: true }}
            name={beneficiaryDetails.name}
            description={getAccountDetails()}
          />
        </Inline>
        <div className="h-8 w-8 overflow-clip rounded-full">
          <img src={currencyFlag} alt="" loading="eager" fetchPriority="high" className="h-full w-full" />
        </div>
      </Inline>
    </label>
  );
};
